import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const RegisterExistingProviderForClient = (APIData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      data: APIData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/RegisterExistingProviderForClient`,
    });
    return response.data;
  } catch (error) {
    return error;
  }
};
